module.exports = require("markdown-it");


//////////////////
// WEBPACK FOOTER
// external "markdown-it"
// module id = 30
// module chunks = 0